import React, { useEffect, useState } from "react";
import { ConcertEntry } from "../components/concert-entry/concert-entry.component";
import VideoBehindText from "../components/video-image-background/video-behind-text.component";
import { concertDetails } from '../data/concert-data';


const SaturdayConcertsPage = () => {
   const INCREMENT = 2;
   const INITIAL_SIZE = 2;
   const [size, setSize] = useState(INITIAL_SIZE);
   const [concerts, setConcerts] = useState(concertDetails.filter((value, index) => (index < INITIAL_SIZE)));
   const [isBottom, setIsBottom] = useState(false);

   useEffect(() => {
      window.addEventListener('scroll', handleScroll);
      return () => window.removeEventListener('scroll', handleScroll);
   }, []);

   function handleScroll() {
      const scrollTop = (document.documentElement
         && document.documentElement.scrollTop)
         || document.body.scrollTop;
      const scrollHeight = (document.documentElement
         && document.documentElement.scrollHeight)
         || document.body.scrollHeight;
      if (scrollTop + window.innerHeight + 50 >= scrollHeight) {
         setIsBottom(true);
      }
   }

   useEffect(() => {
      if (isBottom) {
         // console.log("isBottom fired, size: " + size);
         setSize((size) => {
            const newSize = size + INCREMENT;
            // console.log("newSize: " + newSize);
            setConcerts(() => {
               setIsBottom(false);
               return concertDetails.filter(
                  (value, index) =>
                     (index < (newSize))
               )
            });
            return newSize
         })
      }
   }, [isBottom]);

   return (
      <div>
         <VideoBehindText mainText="Saturday Concerts" url="bg.jpg">
            <div className="grid grid-cols-1 mx-auto px-0 lg:px-1">
               {
                  concerts.map(
                     (concert, index) => (
                        <ConcertEntry key={index} {...concert} />
                     )
                  )

               }
            </div>
         </VideoBehindText>
         <div>
            Showing {size} videos
      </div>

      </div>
   )
};

export default SaturdayConcertsPage